var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9055 8.35088L17.7145 8.11641C17.5881 7.9612 17.3837 7.9612 17.2573 8.11641L12.0015 14.5725L6.74304 8.11641C6.61663 7.9612 6.4122 7.9612 6.28579 8.11641L6.09481 8.35088C5.9684 8.50609 5.9684 8.75707 6.09481 8.91228L11.7702 15.8836C11.8966 16.0388 12.101 16.0388 12.2275 15.8836L17.9028 8.91228C18.0319 8.75707 18.0319 8.50609 17.9055 8.35088Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4730_3171",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 12,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9055 8.35088L17.7145 8.11641C17.5881 7.9612 17.3837 7.9612 17.2573 8.11641L12.0015 14.5725L6.74304 8.11641C6.61663 7.9612 6.4122 7.9612 6.28579 8.11641L6.09481 8.35088C5.9684 8.50609 5.9684 8.75707 6.09481 8.91228L11.7702 15.8836C11.8966 16.0388 12.101 16.0388 12.2275 15.8836L17.9028 8.91228C18.0319 8.75707 18.0319 8.50609 17.9055 8.35088Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4730_3171)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#262626"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.ba45366e2a20b69f8d503f9c2881536b.svg";
export { ForwardRef as ReactComponent };